import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
//import { useMsal } from "@azure/msal-react";
import React from "react";
import TSGrid from "../../../common/components/ui/TSGrid";

const DeleteConversationDialog = ({
  open,
  onClose,
  isMobile,
  removeFromHistory,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "30px",
          maxWidth: "550px",
          ...(isMobile && {
            borderRadius: "15px",
          }),
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">
        <TSGrid container>
          <TSGrid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              variant="tsh4"
              sx={{
                fontSize: "30px",
                lineHeight: "45px",
                color: "#1B738A",
                ...(isMobile && {
                  fontSize: "20px",
                  lineHeight: "30px",
                }),
              }}
            >
              Supprimer la conversation?
            </Typography>
          </TSGrid>
        </TSGrid>
      </DialogTitle>
      <DialogContent
        sx={{ padding: "0px", overflowX: "hidden", paddingBottom: "40px" }}
      >
        <TSGrid container spacing={2} mt={"1px"} ml={"10px"}>
          <TSGrid
            item
            xs={12}
            sx={{
              paddingTop: "10px",
              paddingBottom: "10px",
              PaddingLeft: "10px",
              PaddingRight: "10px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            Cette action est irreversible, voulez-vous continuer?
          </TSGrid>
          <TSGrid
            item
            xs={12}
            sx={{
              textAlign: "end",
              mr: "50px",
            }}
          >
            <Button
              variant="contained"
              sx={{
                background: "rgb(247, 247, 247)",
                color: "#000",
                padding: "5px 40px",
                borderRadius: "9px",
                textTransform: "none",
                "&:hover": {
                  color: "#fff",
                },
          ...(isMobile && { 
            padding: "5px 20px",
           }),
              }}
              onClick={() => onClose()}
            >
              Annuler
            </Button>
            <Button
              variant="contained"
              sx={{
                marginLeft: "10px",
                background:
                  "linear-gradient(274.25deg, #2DC5EE -48.01%, #15C087 140.23%)",
                color: "#fff",
                padding: "5px 40px",
                borderRadius: "9px",
                textTransform: "none",
                "&:hover": {
                  background:
                    "linear-gradient(90deg, rgb(84, 131, 86) 0%, rgb(17, 111, 118) 100%)",
                },
              }}
              onClick={() => removeFromHistory()}
            >
              Continuer
            </Button>
          </TSGrid>
        </TSGrid>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteConversationDialog;
